import { render } from "./sharewell_marketing_header.vue?vue&type=template&id=788cb874"
import script from "./sharewell_marketing_header.vue?vue&type=script&lang=js"
export * from "./sharewell_marketing_header.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__